import createDecorator from 'final-form-focus'

export const focusOnError = createDecorator() // eslint-disable-line import/prefer-default-export
